import { Injectable } from "@angular/core";

import { BackendUrl } from "./../../models/domains/urls/back-end.url";
import { PageableResult } from "../../models/domains/paginator/pageable-result";
import { PagingRequest } from "../../models/domains/paginator/paging-request";
import { RemoteGatewayFactory } from "../../gateways/remote-gateway-factory";
import { FindSalesHistoryParser } from "../parsers/pbm/sales-history/find-sales-history.parser";
import { FindSalesHistoryByFiscalNumberParser } from "../parsers/pbm/sales-history/find-sales-history-by-fiscal-number.parser";
import { SalesHistoryCompany } from "../../models/domains/pbm/sales-history/sales-history-company";
import { UserRoleMediator } from "../mediators/user-role.mediator";

@Injectable()
export class SalesHistoryRepository {
  constructor(
    private remoteGatewayFactory: RemoteGatewayFactory,
    private findSalesHistoryParser: FindSalesHistoryParser,
    private findSalesHistoryByFiscalNumberParser: FindSalesHistoryByFiscalNumberParser,
    private userRoleMediator: UserRoleMediator,
  ) {}

  public async findSalesHistory(filterText: string, pagingRequest: PagingRequest): Promise<PageableResult> {
    const body = JSON.stringify({
      StartIndex: pagingRequest.getStart(),
      TotalPerPages: pagingRequest.getEnd(),
      FilterBy: pagingRequest.getFilterText(),
      FilterText: filterText,
    });
    const headers = {
      "Content-Type": "application/json",
      "X-CompanyFiscalNumberRoot-Filter": this.userRoleMediator.getCompanyFiscalNumberRoot(),
    };
    try {
      const data = await this.remoteGatewayFactory
        .createDefaultRemoteGateway()
        .postWithHeaders(new BackendUrl("/api/sales/history/company/summary"), body, headers);
      return this.findSalesHistoryParser.parse(data);
    } catch (error) {
      return await Promise.reject(error);
    }
  }

  public async findSalesHistoryByFiscalNumber(pagingRequest: PagingRequest): Promise<SalesHistoryCompany> {
    const body = JSON.stringify({
      StartAt: `${pagingRequest.getOptions()[0].getValue()} 00:00`,
      EndAt: `${pagingRequest.getOptions()[1].getValue()} 23:59`,
      StartIndex: pagingRequest.getStart(),
      TotalPerPages: pagingRequest.getEnd(),
      ProductManufacturer: pagingRequest.getOptions()[2].getValue(),
      ProductType: pagingRequest.getOptions()[3].getValue(),
      FiscalNumber: pagingRequest.getOptions()[4].getValue(),
    });

    const headers = {
      "Content-Type": "application/json",
      "X-CompanyFiscalNumberRoot-Filter": this.userRoleMediator.getCompanyFiscalNumberRoot(),
    };

    try {
      const data = await this.remoteGatewayFactory
        .createDefaultRemoteGateway()
        .postWithHeaders(new BackendUrl("/api/sales/history/company"), body, headers);
      return this.findSalesHistoryByFiscalNumberParser.parse(data);
    } catch (httpErrorResponse) {
      if (httpErrorResponse.error) {
        return await Promise.reject(httpErrorResponse.error.Data.ErrorMessage);
      } else if (httpErrorResponse.status == 404) {
        return await Promise.reject("Empresa não encontrada");
      }
    }
  }
}
